export const pagePaths = {
  intro: '/', // #000 Intro Page
  main: '/main', // #001 Main Page
  direction: '/direction', // #002 Direction Page
  navi: '/navi', // #003 pathfinding Page
  parking: '/parking', // #004 Parking Page
  xrnavi: '/xr-navi', // #005 XR Navigation Page
};

export const apiPaths = {
  // awsBaseUrl: "https://api.broz.co.kr/",
};

export const externalUrls = {};
